module.exports = __webpack_public_path__ + "img/icon-sierras-le_hannahwhiteley.a823012.png";